import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';

import amex from '../../../images/cc/american_express.gif';
import visa from '../../../images/cc/visa.gif';
import discover from '../../../images/cc/discover.gif';
import mastercard from '../../../images/cc/mastercard.gif';

const CARDS = {
    Visa: visa,
    'American Express': amex,
    Discover: discover,
    MasterCard: mastercard,
};

const styles = theme => ({
    root: {
        height: '80px',
        display: 'flex',
    },
    logo: {
        border: 'solid 1px #f0f0f0',
        borderRadius: '4px',
        width: '130px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
    Visa: {
        width: '68px',
        height: '42px',
    },
    'American Express': {
        width: '55px',
        height: '47px',
    },
    Discover: {
        width: '67px',
        height: '42px',
    },
    Mastercard: {
        width: '65px',
        height: '41px',
    },
    body: {
        flex: '1 1 auto',
        margin: '0 0 0 16px',
    },
});
function maskAccounNumber(cardNumber) {
    if (cardNumber) {
        return `**** ${cardNumber.substr(cardNumber.length - 4)}`;
    }
    return '';
}

function Info({ classes, payment }) {
    const method = `${payment.payment_method} ${maskAccounNumber(
        payment.payment_last_four
    )}`;

    const expires = `Expires ${payment.payment_expiration_month} / ${payment.payment_expiration_year}`;

    if (Boolean(payment.payment_method)) {
        return (
            <div className={classes.root}>
                <div className={classes.logo}>
                    <img
                        src={CARDS[payment.payment_method]}
                        className={classes[payment.payment_method]}
                        alt="Card Logo"
                    />
                </div>
                <div className={classes.body}>
                    <Typography
                        component="div"
                        variant="body2"
                        className={classes.account}
                    >
                        {method}
                    </Typography>
                    <Typography
                        component="div"
                        variant="body2"
                        color="textSecondary"
                        className={classes.expire}
                    >
                        {expires}
                    </Typography>
                </div>
            </div>
        );
    }
    return <Typography>No payment information on file</Typography>;
}

export default withStyles(styles)(Info);
